import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import updateAction from "../updateAction";
import "./CheckoutForm.scss";
import TextField from "./Forms/TextField";
import DonationOptions from "./Forms/DonationOptions";
import MultiStepForm from "./Forms/MultiStepForm";
import AddMoreFields from "./Forms/AddMoreFields";
import mailCheck from "mailcheck";
import { TransitionGroup } from "react-transition-group";
import Fade from "./Fade";
import SelectField from "./Forms/SelectField";
import prefixOptions from "./Forms/prefixOptions";
import suffixOptions from "./Forms/suffixOptions";
import {
  getHonoreePresets,
  getJointGiftPresets,
  getPledgePresets,
  resetPledgePresets,
} from "../services/funds.service";
const CheckoutYourInfo = () => {
  const { state, actions } = useStateMachine({ updateAction });
  const [emailSuggestion, setEmailSuggestion] = useState(null);
  const currentStep = "CheckoutYourInfo";
  let checkoutDetails = state.checkoutDetails;
  const jointGiftPresets = getJointGiftPresets();
  const pledgePresets = getPledgePresets();
  const honoreePresets = getHonoreePresets();
  if (pledgePresets) {
    checkoutDetails.isPledgePayment = pledgePresets.isPledge;
  }

  const {
    formState: {
      isValid,
      errors,
    },
    handleSubmit,
    watch,
    register,
    control,
    trigger,
    setValue,
  } = useForm({
    mode: "onTouched",
    defaultValues: checkoutDetails,
  });

  React.useEffect(() => {
    setValue("isPledgePayment", state.checkoutDetails.isPledgePayment);
  }, [state]);

  const moreFields = watch(`${currentStep}More`);

  function onSuggestion(suggestion) {
    setEmailSuggestion(suggestion?.full);
  }

  return (
    <MultiStepForm
      state={state}
      actions={actions}
      handleSubmit={handleSubmit}
      isValid={isValid}
      currentStep={currentStep}
    >
      <div className="checkout-form__title-wrapper">
        <h2 className="checkout-form__title">Your Information</h2>
      </div>
      <div className="checkout-form__fields">
        <TextField
          label="Email Address *"
          name="yourEmail"
          placeholder="Your Email"
          errors={errors}
          register={register}
          onBlur={(e) => {
            mailCheck.run({
              domains: [
                "gmail.com",
                "yahoo.com",
                "hotmail.com",
                "aol.com",
                "msn.com",
                "emory.edu",
                "alumni.emory.edu",
                "emoryhealthcare.org",
              ],
              email: e.target.value,
              suggested: onSuggestion,
              empty: onSuggestion,
            });
          }}
          registerOptions={{
            required: {
              value: true,
              message: "*Required field",
            },
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            },
          }}
        >
          {emailSuggestion && (
            <label
              className="message message--suggestion"
              onClick={() => {
                setValue("yourEmail", emailSuggestion);
                setEmailSuggestion(null);
              }}
              title="Click here to use this suggestion"
            >
              Did you mean <em>{emailSuggestion}</em>?
            </label>
          )}
        </TextField>
        <TransitionGroup component={null}>
          <Fade toggle={moreFields} timeout={200}>
            <SelectField
              label="Prefix"
              name="prefix"
              placeholder="Prefix"
              control={control}
              options={prefixOptions}
            />
          </Fade>

          <TextField
            label="First Name *"
            name="firstName"
            placeholder="First Name"
            size="half"
            errors={errors}
            register={register}
            registerOptions={{
              required: {
                value: true,
                message: "*Required field",
              },
              maxLength: 100,
            }}
          />
          <Fade toggle={moreFields} timeout={200}>
            <TextField
              label="Middle Name"
              name="middleName"
              placeholder="Middle Name"
              size="half"
              errors={errors}
              register={register}
              registerOptions={{
                maxLength: 100,
              }}
            />
          </Fade>

          <TextField
            label="Last Name *"
            name="lastName"
            placeholder="Last Name"
            size="half"
            errors={errors}
            register={register}
            registerOptions={{
              required: {
                value: true,
                message: "*Required field",
              },
              maxLength: 100,
            }}
          />
          <Fade toggle={moreFields} timeout={200}>
            <SelectField
              label="Suffix"
              name="Suffix"
              placeholder="Suffix"
              size="half"
              control={control}
              options={suffixOptions}
            />
          </Fade>
        </TransitionGroup>

        <AddMoreFields
          label={`${moreFields ? "Hide" : "Show"} Prefix, Suffix, Middle Name`}
          name={`${currentStep}More`}
          register={register}
        />

        {(jointGiftPresets &&
          jointGiftPresets.hide &&
          pledgePresets &&
          pledgePresets.hide &&
          honoreePresets &&
          honoreePresets.hide) || (
          <div className="checkout-form__field  checkout-form__field--options">
            <h2 className="checkout-form__title checkout-form__title--donation-options">
              Donation Options
            </h2>

            <DonationOptions
              options={["memory", "honor"]}
              control={control}
              name="donationOptions"
            />
            {(!jointGiftPresets ||
              (jointGiftPresets && !jointGiftPresets.hide)) && (
              <>
                <div className="checkout-form__field">
                  <div className="form-switch">
                    <label>
                      <input
                        type="checkbox"
                        id="joint-gift"
                        {...register('jointGift',
                          {
                            onChange: () => trigger("jointGift"),
                          }
                        )}
                      />
                      Joint Gift
                    </label>
                  </div>
                </div>
              </>
            )}
            {(!pledgePresets || (pledgePresets && !pledgePresets.hide)) && (
              <>
                <div className="checkout-form__field">
                  <div className="form-switch">
                    <label>
                      <input
                        type="checkbox"
                        id="pledge-payment"
                        onChange={() => {
                          resetPledgePresets();
                          return trigger("isPledgePayment");
                        }}
                        {...register('isPledgePayment')} />
                      This is a Pledge Payment
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </MultiStepForm>
  );
};

export default CheckoutYourInfo;
